import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';

// Components
//import * as icons from '../Icons/Icons';

const Pricing = observer(class Pricing extends React.Component {
  constructor() {
    super();
    this.handleVoucher = this.handleVoucher.bind(this);
    this.applyVoucher = this.applyVoucher.bind(this);
    this.removeVoucher = this.removeVoucher.bind(this);
    this.toggleVoucher = this.toggleVoucher.bind(this);
  }

  componentWillMount() {
    this.state = {
      showVoucher: false,
      voucherCode: null
    }
  }

  cleanQuery(query) {
    if (!query) return '';
    // Remove any existing voucher code parameters
    if(query.indexOf('&voucherCode') > -1) {
      let queryParams = query.split('&');

      for(let i = 0; i < queryParams.length; i++) {
        if(queryParams[i].indexOf('voucherCode') > -1) {
          queryParams.splice(i, 1);
        }
      }

      return queryParams.join('&');
    } else if(query.indexOf('?voucherCode') > -1) {
      return '';
    }

    return query;
  }

  handleVoucher() {
    const { ProctorStore, ScheduleStore } = this.props.store;
    const voucherCode = this.voucher_code.value;

    this.setState({
      voucherCode
    });

    let query = this.cleanQuery(ProctorStore.searchQuery);

    // Add the new voucher code as a parameter
    if(!query) {
      query = `?voucherCode=${voucherCode}`;
    } else {
      query += `&voucherCode=${voucherCode}`;
    }
    if (this.props.scheduler.state) {
      query += `&examSessionSid=${[this.props.scheduler.state.sessionSid]}`;
      query += `&proctorLocationSids=${[this.props.scheduler.state.proctorLocationSid]}`;
    }
    if (ScheduleStore.appointmentDate) {
      query += `&appointmentDate=${ScheduleStore.appointmentDate}`;
    }

    // Perform a new search to get the fees
    const _this = this;

    setTimeout(function(){
      ProctorStore.searchProctors(query, _this.applyVoucher, 0, true);
    });
  }

  applyVoucher(i, proctors) {
    this.props.store.ScheduleStore.voucherCode = this.state.voucherCode || null;

    let voucherCode = null;

    if(proctors[0].fees.voucherApplied) {
      voucherCode = this.state.voucherCode
    }else{
      this.props.store.SessionStore.showDialog(this.props.translation.voucher_invalid_dialog);
    }

    this.props.scheduler.setState({
      fees: proctors[0].fees,
      voucherCode
    });
  }

  removeVoucher() {
    const { ProctorStore } = this.props.store;

    let query = this.cleanQuery(ProctorStore.searchQuery);

    // Perform a new search to remove the voucher
    ProctorStore.searchProctors(query, this.applyVoucher, 0, true);
  }

  toggleVoucher() {
    this.setState({
      showVoucher: !this.state.showVoucher
    });
  }

  render() {
    const { fees, translation } = this.props;
    const { SessionStore, PaymentStore } = this.props.store;

    if(fees) {
      return (
        <div>
          <h2 className="panel__title">{translation.title}</h2>

          <ul className="pricing">
            <li className="pricing__discount">
              <span className="pricing__item">{translation.session}</span>
              <span className="pricing__price">
                {currencyFormatter.format(fees.preFundingRuleTotal, {code: fees.currencyCode})} {fees.currencyCode}
              </span>
            </li>
            { PaymentStore.schedulingRuleInformation.map((rule) =>
              <li className="pricing__discount">
                <span className="pricing__item">{rule.name}</span>
                <span className="pricing__price">
                  {currencyFormatter.format(rule.feeAmount, {code: fees.currencyCode})} {fees.currencyCode}
                </span>
              </li>
            )}
            {fees.voucherSid &&
              <li className="pricing__discount">
                <span className="pricing__item">{translation.voucher}</span>
                <span className="pricing__price">
                  -{currencyFormatter.format(fees.voucherTotal, {code: fees.currencyCode})} {fees.currencyCode}
                </span>
              </li>
            }
            <li className="pricing__total">
              <span className="pricing__item">{translation.total}</span>
              <span className="pricing__price">
                {currencyFormatter.format(fees.userTotal, {code: fees.currencyCode})} {fees.currencyCode}
              </span>
            </li>
          </ul>

          {fees.voucherSid && fees.remainingVoucherTotal > 0 &&
            <p className="note">
              {translation.voucher_remaining} {currencyFormatter.format(fees.remainingVoucherTotal, {code: fees.currencyCode})} {fees.currencyCode}
            </p>
          }

          {!fees.voucherSid && !this.state.showVoucher &&
            <button
              className="btn--link pricing-adjust"
              onClick={this.toggleVoucher}
            >
              {translation.initiate_voucher}
            </button>
          }

          {!fees.voucherSid && this.state.showVoucher &&
            <form
              className={`pricing-form form-inline ${SessionStore.backgroundLoadingCalls.length > 0 ? 'working' : ''}`}
              onSubmit={(e) => checkValidity(e, this.handleVoucher)}
              noValidate
            >
              <ul className="fields">
                <li>
                  <label className="meta" htmlFor="voucher-code">{translation.voucher_code}</label>
                  <input
                    id="voucher-code"
                    type="text"
                    placeholder={translation.voucher_code}
                    ref={(input) => {this.voucher_code = input}}
                    required
                    aria-required="true"
                  />
                </li>
              </ul>

              <button
                className="btn--outline"
                type="submit"
              >{translation.apply}</button>
              <button className="btn--link" onClick={this.toggleVoucher}>Cancel</button>
            </form>
          }
        </div>
      )
    }

    return null;
  }
})

export default translate('Pricing')(Pricing);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/Pricing.js